import { Switch as MantineSwitch, SwitchProps as MantineSwitchProps } from "@mantine/core";

const Switch = ({ ...props }: MantineSwitchProps) => {
  return <MantineSwitch withThumbIndicator={false} {...props} />;
};

export default Switch;
